import React from "react";
import { Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ServicesCard } from "./ServicesCard/ServicesCard";

type ServiceCardData = { title: string; descriptions: string[] };

export const ServicesCards: React.FC = () => {
  const { t } = useTranslation();
  const servicesCardsMock = t("services.cards", {
    returnObjects: true,
  }) as ServiceCardData[];

  return (
    <Grid2
      container
      columns={{ xs: 4 }}
      spacing={4}
      direction="row"
      alignItems="stretch"
    >
      {servicesCardsMock.map((projectCard, index) => (
        <ServicesCard
          key={projectCard.title}
          title={projectCard.title}
          descriptions={projectCard.descriptions}
          index={index + 1}
        />
      ))}
    </Grid2>
  );
};
